<template>
  <div class="identityInfo" v-loading.fullscreen.lock="sonLoading">
    <div class="info-center">
      <div class="kyc-icon"></div>
      <!-- 需要得到法人的同意才能开立账户。请告诉我们贵公司主要法人的身份 -->
      <div class="title" >
        {{
        location == "TERRITORY"
        ? $t('kycFile.identityInfo.tit')
        : $t('kycFile.identityInfo.titSec')
        }}
      </div>
      <lls-form
        :inline="true"
        label-position="top"
        class="demo-ruleForm"
        :model="manager"
        :rules="rulesIden"
        ref="ruleForm"
      >
        <!-- 请选择你所有的身份(可多选) -->
        <lls-form-item :label="$t('kycFile.identityInfo.identities')" prop="position" class="label-special">
          <lls-checkbox-group v-model="manager.position" @change="changePosition">
            <lls-checkbox
              v-for="item in positionElseArr"
              :key="item.dictKey"
              :label="item.dictParam"
            >{{ item.dispalyName }}</lls-checkbox>
          </lls-checkbox-group>
        </lls-form-item>
        <p class="sub-title"  style="width:720px; ">
         {{ $t('kycFile.identityInfo.infomation') }}
        </p>
        <!-- 请选择证件签发地 -->
         <div class="bg-item">
        <lls-form-item :label="$t('kycFile.identityInfo.certificateIssuingPlace')" prop="certificateIssuingPlaceCode">
          <lls-select
            v-model="manager.certificateIssuingPlaceCode"
            filterable
            clearable
            :placeholder="$t('common.selectPlaceholder')"
          >
            <lls-option
              v-for="item in countryList"
              :key="item.id"
              :label="item.countryName"
              :value="item.countryCode"
            ></lls-option>
          </lls-select>
        </lls-form-item>
        <lls-form-item :label="$t('kycFile.identityInfo.docType')" prop="identType">
          <lls-select v-model="manager.identType" clearable :placeholder="$t('common.selectPlaceholder')">
            <lls-option
              v-for="item in certificatesObj"
              :key="item.dictKey"
              :label="item.dispalyName"
              :value="item.dictParam"
            ></lls-option>
          </lls-select>
        </lls-form-item>
        </div>
        <div>
          <!-- 证件（正面） -->
          <div
            class="com-word"
            style="width:320px;margin-bottom:0px;"
          ><span class="require">*</span> {{$t('common.certificateFront')}}</div>
          <kycUpload
            type="half"
            v-if="manager.mediaId"
            :mediaId="manager.mediaId"
            :limit="1"
            modelCode="MKJ02CONTACT"
            catgId="CCONTACT001"
            @toOcr="ocrEvent"
            ref="certificateFront"
          ></kycUpload>
        </div>
        <div>
          <!-- 证件（反面） -->
          <div
            class="com-word"
            style="width:320px;margin-bottom:0px;"
          ><span class="require">*</span> {{$t('common.certificateBack')}}</div>
          <kycUpload
            type="half"
            v-if="manager.mediaId"
            :mediaId="manager.mediaId"
            :limit="1"
            modelCode="MKJ02CONTACT"
            catgId="CCONTACT002"
            ref="certificateBack"
          ></kycUpload>
        </div>
        <div class="bg-item">
        <lls-form-item :label="$t('kycFile.identityInfo.idNum')" prop="identNo">
          <lls-input
            type="text"
            v-model.trim="manager.identNo"
            clearable
            autocomplete="off"
            maxlength="20"
            @input="changeInput($event)"
            :placeholder="$t('common.inputPlaceholder')"
          ></lls-input>
        </lls-form-item>
        <lls-form-item :label="$t('kycFile.identityInfo.familyName')" prop="lastName">
          <lls-input
            type="text"
            v-model.trim="manager.lastName"
            clearable
            autocomplete="off"
            maxlength="50"
            @input="changeInput($event)"
            :placeholder="$t('common.inputPlaceholder')"
          ></lls-input>
        </lls-form-item>
        <lls-form-item :label="$t('kycFile.identityInfo.firstName')" prop="firstName">
          <lls-input
            type="text"
            v-model.trim="manager.firstName"
            clearable
            autocomplete="off"
            maxlength="50"
            @input="changeInput($event)"
            :placeholder="$t('common.inputPlaceholder')"
          ></lls-input>
        </lls-form-item>
        <lls-form-item :label="$t('kycFile.identityInfo.email')" prop="email">
          <lls-input
            type="text"
            v-model.trim="manager.email"
            clearable
            autocomplete="off"
            maxlength="255"
            :placeholder="$t('common.inputPlaceholder')"
          ></lls-input>
        </lls-form-item>
        <lls-form-item :label="$t('kycFile.identityInfo.phone')" required>
          <div class="telephone-class">
            <lls-form-item prop="phoneAreaCode">
              <lls-select 
                v-model="manager.phoneAreaCode" 
                filterable
                clearable
                :placeholder="$t('common.selectPlaceholder')"
                popper-class="country-code-drop"
                :filter-method="fitlerCountry">
                <lls-option
                  v-for="item in countryCodeList"
                  :key="item.countryCode"
                  :label="'+' + item.phoneCode"
                  :value="item.phoneCode">
                  <span>{{ '+' + item.phoneCode + ' ' + ($i18n.locale === 'zh' ? item.chineseName : item.englishName) }}</span>
                </lls-option>
              </lls-select>
            </lls-form-item>
            <lls-form-item prop="phone">
              <lls-input
                type="text"
                v-model.trim="manager.phone"
                clearable
                autocomplete="off"
                maxlength="20"
                :placeholder="$t('common.inputPlaceholder')"
                @input="
                  value => (manager.phone = value.replace(/[^\d]/g, ''))
                "
              ></lls-input>
            </lls-form-item>
          </div>
          
        </lls-form-item>
      </div>
      </lls-form>
    </div>
    <lls-dialog
      custom-class="check-user-info-dialog"
      title
      :visible.sync="checkFailed"
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="dialog-content">
        <div class="title">{{ $t('kycFile.identityInfo.updateUserTitle') }}</div>
        <div class="tips">{{ $t('kycFile.identityInfo.updateUserTip1') }}</div>
        <div class="tips">{{ $t('kycFile.identityInfo.updateUserTip2') }}</div>
      </div>
      <div slot="footer">
        <lls-button type="primary" @click="handleConfirm">
          {{
          $t('kycFile.identityInfo.confirm')
          }}
        </lls-button>
      </div>
    </lls-dialog>
  </div>
</template>
<script>
import kycUpload from './kycUpload.vue';
export default {
  name: 'identityInfo',
  components: { kycUpload },
  data() {
    let validatePass1 = (rule, value, callback) => {
      let regEmail = /^[a-zA-Z0-9\.!#\$%&\'\*\+\/=\?_`\{\|\}\~\-\(\)\$\%\\\|\/\,\<\>\^]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (value === '') {
        // 请输入邮箱
        callback(new Error(this.$t('kycFile.identityInfo.email')))
      } else if (!regEmail.test(value)) {
        // 邮箱格式错误
        callback(new Error(this.$t('kycFile.identityInfo.emailFormat')))
      } else {
        callback()
      }
    }
    return {
      allOptions:[],
      countryCodeList:[],
      checked: false,
      enterpriseId: sessionStorage.getItem('enterpriseId'),
      location: sessionStorage.getItem('location'),
      positionElseArr: [],
      countryList: [],
      sonLoading: false,
      manager: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        identType: null,
        identNo: null,
        id: null,
        mediaId: null,
        phoneDisab: false,
        emailDisab: false,
        position: [],
        certificateIssuingPlaceCode: null,
        certificateIssuingPlace: null,
        enterpriseId: sessionStorage.getItem('enterpriseId')
      },
      checkFailed: false,
      rulesIden: {
        position: [
            { type: 'array',  required: true, message: this.$t('kycFile.identityInfo.identities'), trigger: 'change' }
          ],
        certificateIssuingPlaceCode:  [
            { required: true,message: this.$t('kycFile.identityInfo.certificateIssuingPlace'), trigger: 'change' }
          ],
        identType:  [
          { required: true,message: this.$t('kycFile.identityInfo.docType'), trigger: 'change' }
        ],
        identNo: [
          { required: true, message: this.$t('kycFile.identityInfo.idNum'), trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: this.$t('kycFile.identityInfo.familyName'), trigger: 'blur' }
        ],
        firstName: [
          { required: true, message: this.$t('kycFile.identityInfo.firstName'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('kycFile.identityInfo.email'), trigger: 'blur' },
          { validator: validatePass1, trigger: ['change', 'blur'] }
        ],
        phone: [
          { required: true, message: this.$t('kycFile.identityInfo.phone'), trigger: 'blur' }
        ],
        phoneAreaCode:[
          { required: true, message: this.$t('kycFile.identityInfo.areaCode'), trigger: ['blur','change'] }
        ]
      },
    };
  },
  computed: {
    certificatesObj() {
      const storedData = sessionStorage.getItem('证件类型em.ComStepStatus');
      const arr = storedData? JSON.parse(storedData) : [];
      return arr.filter(item =>
        ['CREDENTIALS_ID', 'CREDENTIALS_PASSPORT', 'CREDENTIALS_OTHER'].includes(item['dictParam'])
      );
    },
    positionObj() {
      const storedData = sessionStorage.getItem('公司职位kj.kyc.PositionEnum');
      return storedData? JSON.parse(storedData) : [];
    }
  },
  async mounted() {
    this.allOptions = this.countryCodeList
    await this.getCountry();
    await this.getManager();
    this.getCountryCodeList()
    this.$refs.ruleForm.clearValidate()
    if (this.location === 'TERRITORY') {
      this.positionElseArr = this.positionObj.filter(item => item['dictParam']!== 'DIRECTOR');
    } else {
      this.positionElseArr = this.positionObj.filter(item => item['dictParam']!== 'LEGAL');
    }
  },
  methods: {
    async getCountryCodeList(){
      const res = await this.$http.get(
        ' /kj-kyc/country/listPhoneAreaCode'
      )
      if (res.data.code !== '200') return
      this.countryCodeList = res.data.data
      this.allOptions = this.countryCodeList
    },
    fitlerCountry(val){
      val = val.toLowerCase()
      if(val.includes("+")) {
        this.countryCodeList = this.allOptions
        return
      }
      if(val){
        this.countryCodeList = this.allOptions.filter(item=>item.phoneCode.includes(val) || (this.$i18n.locale === 'zh' ? item.chineseName.toLowerCase() : item.englishName.toLowerCase()).includes(val))
      } else {
        this.countryCodeList = this.allOptions
      }
    },
    changeInput(e) {
      this.$forceUpdate();
    },
    async getCountry() {
      this.sonLoading = true;
      try {
        const { data } = await this.$API.kycFile.getCountry({});
        this.countryList = data?.data || [];
      } catch (error) {
      } finally {
        this.sonLoading = false;
      }
    },
    async getManager() {
      this.sonLoading = true;
      try {
        const { data } = await this.$API.kycFile.getManager(this.enterpriseId);
        if (data?.data) {
          const tl = data.data || {};
          const filteredData = this.filterObjectDict(tl);
          filteredData.mediaId = filteredData.id;
          filteredData.position = filteredData.position ? this.filterObjectDict(filteredData.position) : []
          if (filteredData.legalPerson) {
            filteredData.legalPerson = null;
          }
          filteredData.phoneDisab = filteredData.registerWay === 'PHONE';
          filteredData.emailDisab =!filteredData.phoneDisab;
          this.manager = filteredData;
        }
      } catch (error) {
      } finally {
        this.sonLoading = false;
      }
    },
    changePosition(val) {
      val.forEach(item => {
        if (item === 'NONE') {
          this.manager.position = ['NONE'];
        }
      });
    },
    ocrEvent(obj) {
      this.$set(this.manager, 'identNo', obj.id_number ? obj.id_number : null);
      this.$set(this.manager, 'lastName', obj.name ? obj.name.substring(0, 1) : null);
      this.$set(this.manager, 'firstName', obj.name ? obj.name.slice(1) : null);
    },
    async nextSon() {
      const isValid = await this.$refs['ruleForm'].validate();
      if (isValid) {
        if(!this.$refs.certificateFront?.fileList.length) {
          this.$message({
          message: this.$t('kycFile.identityInfo.certificateFrontTip'),
          type: 'warning'
        })
        return
        } else if (!this.$refs.certificateBack?.fileList.length) {
          this.$message({
          message: this.$t('kycFile.identityInfo.certificateBackTip'),
          type: 'warning'
        })
        return
        }
        this.checkFailed =!(await this.checkUser());
        if (!this.checkFailed) {
          this.nextSonAfter();
        } else {
          return false;
        }
      }
    },
    nextSonAfter() {
      this.sonLoading = true;
      return this.$API.kycFile.saveManager(this.manager).then(
        ({ data }) => {
          if (data.code === '200') {
            if (!this.checkFailed) {
              this.$emit('toNext');
            }
          } else {
            this.$message.error(data.message);
          }
        }
      ).finally(err=>{
        this.sonLoading = false;
      })
    },
    beforeSon() {
      const query = {
        enterpriseId: this.enterpriseId,
        manager: this.manager
      };
      this.sonLoading = true;
      return this.$API.kycFile.stagedManager(query).then(
        ({ data }) => {
          if (data.code === '200') {
            this.$emit('toBefore');
          } else {
            this.$message.error(data.message);
          }
          this.sonLoading = false;
        },
        (error) => {
          this.sonLoading = false;
        }
      );
    },
    async checkUser() {
      try {
        const { firstName, lastName, email, phone: telephone } = this.manager
        const { data } = await this.$API.kycFile.validateUserAssociation({
          firstName,
          lastName,
          email,
          telephone
        })
        if (data.code !== '200') return false
        return data.data
      } catch (error) {}
    },
    async handleConfirm() {
      try {
        const currentUserInfo =
          JSON.parse(sessionStorage.getItem('objCurUserInfo')) || {}
        this.nextSonAfter()
        const { firstName, lastName, email, phone: telephone } = this.manager
        const { data: data2 } = await this.$API.kycFile.editManageUser({
          userId: currentUserInfo.id,
          firstName,
          lastName,
          email,
          telephone
        })
        if (this.checkFailed) {
          this.$emit('toNext')
        }
        if (data2.code !== '200') return
      } catch (error) {}
    }
  },
};
</script>
<style lang="scss" scoped>
@import '../kycCommon.scss';
.identityInfo {
  width: 100%;
  height: 100%;
  //   overflow-y: auto;
  white-space: normal;
  .info-center {
    width: 720px;
    margin: 0 auto;
    // text-align: center;
    .telephone-class{
      width: 348px !important;
      display: flex;
      ::v-deep .lls-input {
        &__inner{
          width: 185px;
        }
      }
      ::v-deep .lls-select {
        margin-right: 5px;
        width: 130px !important;
        .lls-input__inner {
          width: 100% !important;
        }
      }
    }
    .kyc-icon {
      width: 44px;
      height: 44px;
      background: url('~@/static/kjaccSonImg/kycIcon.png') center center
        no-repeat;
      margin: 0 auto;
    }
    .title {
      color: rgba(46, 90, 153, 1);
      text-align: center;
      padding: 14px 0 26px 0;
      line-height: 24px;
      font-weight: 600;
      font-size: 20px;
    }
    .eng-tip {
      font-size: 12px;
      line-height: 20px;
      color: #89929e;
    }
    .com-word {
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      margin-bottom: 10px;
      .require {
        color: #ff4c65;
      }
    }
    .item-check {
      width: 720px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 15px;
      .check-word {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        margin-left: 8px;
        margin-top: 1px;
      }
    }
    .requ-red {
      position: absolute;
      top: -32px;
      left: 0px;
      color: #ff4c65;
    }
    .label-special ::v-deep .lls-form-item__label {
      color: rgba(46, 90, 153, 1);
      font-weight: 500;
    }
    .long-term {
      width: 320px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 28px;
      .term-word {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        margin-left: 8px;
        margin-top: 1px;
      }
    }
    .shareholder {
      width: 720px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 20px;
      .share-button {
        display: flex;
        justify-content: flex-start;
        .share-word {
          color: #3e8cfa;
          text-decoration-line: underline;
          cursor: pointer;
          margin-right: 10px;
        }
      }
    }
    ::v-deep .lls-form-item__label {
      margin-left: 9px;
    }
    .requ-red {
      position: absolute;
      top: -32px;
      left: 0px;
      color: #ff4c65;
    }
    .sub-title {
      color: rgba(46, 90, 153, 1);
      font-weight: 500;
    }
    .bg-item {
      padding: 12px 20px;
      margin: 20px 0;
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      background: rgba(247, 251, 255, 1);
    }
  }
  .allLine {
    width: 100%;
    .lls-input {
      width: 320px;
    }
  }
  .check-user-info-dialog {
    margin-top: calc((100vh - 200px) / 2) !important;

    .dialog-content {
      .title {
        display: flex;
        justify-content: center;
        font-size: 16px;
        font-weight: 600;
        color: #2e5a99;
      }

      .tips {
        margin-top: 20px;
        font-size: 14px;
        font-weight: 600;
        text-wrap: wrap;
        &:last-child {
          margin-top: 12px;
        }
      }
    }
  }
}
</style>
